import styled from "styled-components";

export const ConditionalDisplay = styled.div.attrs({
  className: "ConditionalDisplay",
})`
  width: 100%;
  display: ${({ $showIf }) => (!!$showIf ? "block" : "none")};
`;
